export const twitchStreamers: string[] = [
    "xQc",
    "Disguised Toast",
    "Ludwig",
    "Shroud"
];